module.exports = __webpack_public_path__ + "img/ic24ViewOff.785e5465.svg";